import { styled, DefaultTextField as TextField } from "@tm/components"

export const TextFieldWithInlineCounter = styled(TextField)(() => ({
    textarea: {
        "&.MuiInputBase-inputMultiline": {
            paddingRight: "5em",
        },
    },
}))
